// What the panel says about the last booking link when it ran out unused.
//
// A link holds its times for a day. If the patient never books, the link
// dies and the panel went back to looking as if none had been sent: nothing
// told the office to follow up, or that the next link would be the second.
// The server already returns every link made for a task, newest first; this
// reads the newest.
//
// Only expires_at is shown. created_at is stored on the database's clock and
// reads hours out; expires_at is written and read on the same clock.
import { heldUntilLabel } from './offerMessage';

interface LinkRow {
  expires_at?: string | null;
  used_at?: string | null;
  revoked_at?: string | null;
}

/** One sentence when the newest link expired without a booking; otherwise null. */
export function lapsedLinkNote(rows: LinkRow[] | null | undefined, now: Date, timeZone: string): string | null {
  const newest = Array.isArray(rows) ? rows[0] : null;
  if (!newest || newest.used_at || newest.revoked_at || !newest.expires_at) return null;
  const expires = new Date(newest.expires_at);
  if (Number.isNaN(expires.getTime()) || expires.getTime() > now.getTime()) return null;
  const when = heldUntilLabel(newest.expires_at, timeZone);
  return when ? `The last link expired on ${when} without a booking.` : null;
}
